// Data Specific Commands the StreamWorker can act on
export const DataCommand = {
  CURSOR_POSITION: 'CURSOR_POSITION',
  EVENT: 'EVENT',
  INIT_SOCKET: 'INIT_SOCKET', // Initialize socket with node server
  USER_LOGIN: 'USER_LOGIN', // User has logged in,
  DELETE_COMPOSITION: 'DELETE_COMPOSITION',
  DELETE_COMPOSITION_RESPONSE: 'DELETE_COMPOSITION_RESPONSE',
  DOC_ENTERED_NOTE: 'DOC_ENTERED_NOTE',
  DOC_LEFT_NOTE: 'DOC_LEFT_NOTE',
  DOC_DELETED_NOTE: 'DOC_DELETED_NOTE',
  DOC_CREATED_NOTE_BY_TOUCH: 'DOC_CREATED_NOTE_BY_TOUCH',
  GET_COMPOSITION_OR_NOTE_REQUEST: 'GET_COMPOSITION_OR_NOTE_REQUEST',
  GET_COMPOSITION_OR_NOTE_RESPONSE: 'GET_COMPOSITION_OR_NOTE_RESPONSE',
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
  SUBMIT_COMPOSITION_REQUEST: 'SUBMIT_COMPOSITION_REQUEST',
  SERVER_SUBMIT_COMPOSITION_RESPONSE: 'SERVER_SUBMIT_COMPOSITION_RESPONSE',
  SECTION_RESPONSE: 'SECTION_RESPONSE',
  SECTION_CONTENT_RESPONSE: 'SECTION_CONTENT_RESPONSE',
  USER_REQUEST: 'USER_REQUEST',
  TOO_MANY_STREAMS: 'TOO_MANY_STREAMS',
  CREATE_NOTE: 'CREATE_NOTE',
  UI_CONTEXT: 'UI_CONTEXT'
}
